/**
 * Created on 3/1/2017.
 * Traditionally, the root reducer file is named index.js
 *
 * This rootReducer config object is passed to Redux.createStore() in
 * configurestore.{env}.js.
 */
import manifestReducer from '@ey/voltron-core/manifest-reducer.js';
import reducerManifest from './manifest.js';
import Env from '../util/env.js';
import errorReducer from './errorreducer';
import initialState from './initialstate.js';
import {
	engagementReducer,
	engagementTeamMembers,
	engagementMetaDataReducer,
	engagementUsersWithRoles,
	countryStatusReducer,
	engagementUserRolesReducer,
	rbacUserRolesReducer,
	workspaceReducer,
	paansReducer,
	getLanguagesReducer,
	getCountriesReducer,
	setEngagementIdReducer,
	setIsAresViewReducer,
	setIsDrawerModeReducer,
	setIsGuidedWorkFlowV2Reducer,
	setIsTrackChangesViewReducer,
	setIsCompareResponsesViewReducer,
	setHasBodyIdFilterReducer,
	setNavigationFilterReducer
} from './Engagements/engagementreducer';
import formActionsReducer from './Form/formActionsReducer'; //we all have to use the same reducer, use the form version, delete the engagement version
import configurationsReducer from './Configurations/configurationsreducer';
import {quickLinkReducer} from './Engagements/quicklinksreducer';
import {userPreferencesReducer, internalUserReducer} from './userpreferences/userpreferencesreducer';
import userPresenceReducer from './UserPresence/userpresencereducer';
import {
	formProfileDataReducer,
	formBodyDataReducer,
	formBodyDisplayDataReducer,
	SubmitIndependenceDataReducer,
	formProfileUpdateDataReducer,
	SubmitIndependenceActionReducer,
	formOverwriteDataReducer,
	SubmitProfileDataReducer,
	IndividualIndependenceDocumentReducer,
	formBodyDisplayDataNoStoreUpdateReducer,
	formBodyDisplayDataForUpdateReducer
} from './FormData/formdatareducer';
import {
	accountAssertionsReducer,
	accountDetailsReducer,
	accountReducer,
	accountTrialBalanceMappingsReducer,
	accountsReducer,
	currentAccountReducerSEM,
	areAllCanvasAccountsMappedToHelixAccountsReducer,
	accountsWithCombinedScotsAndRisksReducer
} from './Accounts/accountsreducer';
import accountMetricsReducer from './Accounts/accountMetricsReducer.js';
import riskMetricsReducer from './Risk/riskMetricsReducer.js';
import {documentsReducer, setDocumentIdReducer, setIsMFEReducer} from './Document/documentsreducer';
import limitedRiskDocumentsReducer from './Document/limitedRiskDocumentsReducer';
import entityDocumentReducer from './Document/entityDocumentReducer';
import {
	validationCountsReducer,
	validationDetailsReducer,
	withoutApprovalvalidationCountsReducer,
	validationFilterValueReducer,
	auditPlanSummaryValidationsReducer
} from './ValidationControl/validationcontrolreducer';
import {assertionsReducer} from './Assertions/assertionsreducer';
import {
	modalRisksReducer,
	risksReducer,
	standardRisksReducer,
	newRiskReducer,
	wcgwRelatedRisksReducer,
	riskReducer,
	relateRiskReducer,
	getAllEngagementRisksReducer,
	risksListReducer,
	listRisksReducer
} from './Risk/riskreducer';
import riskTypeReducer from './RiskType/riskTypeReducer';
import riskFactorReducer from './RiskFactor/riskFactorReducer';
import {buildTasksReducer, taskListReducer, taskListReducerForWCGW, taskRelateUnrelateReducer} from './Task/tasklistreducer';
import {timephaseReducer} from './Timephase/timephasereducer';
import VersionUpgradeStateReducer from './versionreducer';
import relatedDocumentsReducer from './RelatedDocuments/relatedDocumentsReducer';
import {relatedObjectsReducer} from './RelatedObjects/relatedobjectsreducer';
import {sectionRelatedObjectsReducer} from './SectionRelatedObjects/sectionrelatedobjectsreducer';
import {modalOpenStateReducer, modalLevelStateReducer, adcModalOpenStateReducer} from './modalopenstatereducer';
import documentExtensionReducer from './Document/documentextensionreducer';
import signOffsReducer from './signoffsreducer';
import engagementCommentsReducer from './EngagementComment/engagementcommentreducer';
import formBodyRelatedDocumentsReducer from './FormBodyRelatedDocuments/formBodyRelatedDocumentsReducer';
import reviewNotesReducer from './ReviewNotes/reviewnotesreducer';
import docHelperDocumentsReducer from './Document/docHelperDocumentsReducer';
import snapshotsReducer from './Snapshot/snapshotsreducer';
import {
	craSnapshotDetailsReducer,
	getITEnvironmentSnapshotById,
	snapshotDetailsReducer,
	snapshotCompareDetailsReducer,
	clearRightSideSnapshotViewReducer,
	showHideRightSideSnapshotViewReducer,
	showHideLeftSideSnapshotViewReducer
} from './Snapshot/snapshotdetailsreducer';
import {wcgwReducer, wcgwsReducer} from './WCGW/wcgwreducer';
import manageObjectsReducer from './ManageObjects/manageobjectsreducer';
import formUsersReducer from './FormUsers/formusersreducer';
import {contentUpdatesReducer} from './ContentUpdates/contentupdatesreducer';
import {itProcessReducer} from './ITProcess/itprocessreducer';
import {standaloneViewReducer} from './standaloneViewReducer';
import {documentLastModifiedDateReducer} from './documentLastModifiedDateReducer';
import {scotsDetailsReducer, scotsWalkthroughReducer} from './Scots/scotsreducer';
import {scotsReducer, scotReducer} from './Scots/scotsreducer';
import {controlAttributesReducer} from './Attributes/controlAttributesReducer';
import {controlsDetailsReducer, controlsReducer, walkthroughControlsReducer} from './Control/controlsReducer';
import {itcontrolDetailsReducer, itcontrolreducer} from './ITControl/itcontrolReducer';
import {itApplicationDataReducer, itApplicationReducer, itApplicationDetailsReducer} from './ITApplication/itapplicationreducer';
import {itRiskReducer} from './ITRisk/itriskreducer';
import {relateItRiskReducer, deficiencyItRisksReducer} from './ITRisk/relateitriskreducer';
import pspIndexesReducer from './PSPIndexes/pspIndexesReducer';
import helixsnapshotreducer from './HelixSnapshot/helixsnapshotreducer';
import captureAnnotationReducer from './CaptureAnnotations/captureAnnotationReducer';
import engagementhelixreducer from './HelixIntegration/engagementhelixreducer';
import helixReducer from './HelixIntegration/helixreducer';
import materialityReducer from './Materiality/materialityreducer';
import journalSourceReducer from './JournalSource/journalsourcereducer';
import formReducer from './Form/formreducer';
import formBodyReducer from './Form/formBodyReducer';
import assessRiskSummaryReducer from './AssessRiskSummary/assessRiskSummaryReducer';
import activeAnnotationReducer from './ActiveAnnotation/activeAnnotationReducer';
import fourFortyGlDocumentsReducer from './Document/fourFortyGlDocumentsReducer';
import duplicateDocumentsReducer from './Document/duplicateDocumentsReducer';
import userSearchReducer from './UserSearch/usersearchreducer';
import userSearchReducerGA from './UserSearch/usersearchreducerGA';
import userreducer from './User/userreducer';
import internalUsersReducer from './InternalUsers/internalusersreducer';
import bodiesSpecialReducer from './BodiesSpecial/bodiesSpecialReducer';
import loadingReducer from './loadingReducer';
import noteDetailsReducer from './NotesModal/rnhnotedetailreducer';
import workspaceEngagementsReducer from './WorkspaceEngagement/workspaceengagementsreducer';
import _assertionsReducer from './Assertions/_assertionreducer';
import _riskReducer from './Risk/_riskReducer';
import sampleItemReducer from './SampleItems/sampleItemReducer';
import filterDataReducer from './Filter/filterdatareducer.js';
import sampleListReducer from './SampleList/sampleListReducer.js';
import sampleItemDocumentReducer from './SampleItemDocuments/sampleItemDocumentsReducer.js';
/* Ares reducers */
import {reducers as aresReducers} from './guidedworkflow';
import {trialBalancesReducer, trialBalanceByIdReducer, trialBalancesMetricsReducer} from './TrialBalance/trialbalancereducer';
import {leadsheetReducer} from './Leadsheet/LeadsheetSlice';
import {estimatesReducer} from './Estimates/estimatesReducer';
import {annotationsReducer} from './Annotations/annotationsreducer';
import {financialStatementReducer} from './FinancialStatement/financialstatementreducer';
import {entityLayersReducer, multiEntityReducer, stEntitiesReducer} from './Ares/MultiEntities/stEntitiesreducer';
import uploadDocumentReducer from './Document/uploaddocumentreducer';
import goToSourceReducer from './GoToSource';
import groupAuditReducer from './GroupAudit';
import {setFormV2ToasterVisibilityReducer} from './toastreducer';
import topHeaderReducer from './TopHeader/topHeaderReducer';
import manageControlsReducer from '../reducers/Control/managecontrolsreducer';
/* Media Playing reducer */
import mediaPlayingReducer from './MediaPlaying/mediaplayingreducer.js';
import bulkRelateReducer from './Document/bulkRelateReducer';
import knowledgeFormsReducer from './Document/knowledgeFormsReducer.js';
import {manageAccountReducer, manageAccountsReducer} from './Accounts/manageaccountsreducer.js';
/*Flow chart */
import {flowChartReducer, flowChartsReducer} from './FlowChart/flowchartreducer.js';
import {flowchartstepReducer} from './FlowChart/flowchartstepreducer.js';
import projectReducer from './Projects/projectReducer.js';
import AIChatBotIntegrationParametersReducer from './Eyq/AIChatBotIntegrationParametersReducer';
import {adobeAnalytics} from '@ey/voltron-analytics';
import filterReducer from './Filter/filterreducer.js';
import tagsreducer from './Tags/tagsreducer.js';
import engagementHelixProjectSummaryReducer from './HelixIntegration/engagementhelixsummaryreducer.js';
import itPlanningReducer from './ITPlanning';
import documenttypesreducer from './Document/documenttypesreducer.js';
import {craAccountValidationCountReducer} from './Accounts/crareducer.js';
import DrawerFormDetailsReducer from './Ares/FormData/DrawerFormDetailsReducer.js';
import {deficienciesReducer} from './Deficiency/deficienciesreducer.js';
import {manageDeficienciesReducer} from './Deficiency/manageDeficienciesReducer.js';
import {deficiencyReducer} from './Deficiency/deficiencyreducer.js';
import {deficiencymetricsreducer} from './Deficiency/deficiencymetricsreducer.js';
import {deficiencyClassTypesReducer} from './Deficiency/deficiencyClassTypesReducer.js';
import engagementProfileReducer from './Engagements/engagementprofilereducer.js';
import customFiltersReducer from './CustomFilters/customFiltersReducer.js';
import knowledgeTechnologyReducer from './KnowledgeTechnology/knowledgeTechnologyReducer.js';
import formFilteredActionsReducer from './Form/formFilteredActionsReducer.js';
import scotMetricsReducer from './Scots/scotMetricsReducer.js';
import misstatementsReducer from './Misstatements/misstatementsReducer.js';
import misstatementDetailsReducer from './Misstatements/misstatementDetailsReducer.js';
import documentSettingConfigurationReducer from './Document/documentSettingConfigurationReducer';
import {engagementTagsReducer, engagementTagReducer} from './EngagementTags/engagementTagsReducer';

const appReducer = manifestReducer(
	{
		...aresReducers,
		_assertions: _assertionsReducer,
		_risks: _riskReducer,
		riskMetrics: riskMetricsReducer,
		account: accountReducer,
		accountAssertions: accountAssertionsReducer,
		accountDetails: accountDetailsReducer,
		accountTrialBalanceMappings: accountTrialBalanceMappingsReducer,
		accounts: accountsReducer,
		accountMetrics: accountMetricsReducer,
		activeAnnotation: activeAnnotationReducer,
		annotations: annotationsReducer,
		appVersion: VersionUpgradeStateReducer,
		assertions: assertionsReducer,
		assessRiskSummary: assessRiskSummaryReducer,
		bodiesSpecial: bodiesSpecialReducer,
		buildTasks: buildTasksReducer,
		bulkRelate: bulkRelateReducer,
		captureAnnotation: captureAnnotationReducer,
		clearRightSideSnapshotView: clearRightSideSnapshotViewReducer,
		configurations: configurationsReducer,
		contentUpdates: contentUpdatesReducer,
		controlAttributes: controlAttributesReducer,
		controlsDetails: controlsDetailsReducer,
		controls: controlsReducer,
		walkthroughControls: walkthroughControlsReducer,
		manageControls: manageControlsReducer,
		countries: getCountriesReducer,
		countryStatus: countryStatusReducer,
		currentAccountSEM: currentAccountReducerSEM,
		customFilters: customFiltersReducer,
		docHelperDocuments: docHelperDocumentsReducer,
		documentExtensions: documentExtensionReducer,
		documentSettingConfiguration: documentSettingConfigurationReducer,
		documentId: setDocumentIdReducer,
		isMFE: setIsMFEReducer,
		documents: documentsReducer,
		documentsLastModifiedInformation: documentLastModifiedDateReducer,
		scotsAndRisksAccountList: accountsWithCombinedScotsAndRisksReducer,
		duplicateDocuments: duplicateDocumentsReducer,
		engagement: engagementReducer,
		engagementProfiles: engagementProfileReducer,
		engagementComments: engagementCommentsReducer,
		engagementHelixProjects: engagementhelixreducer,
		engagementHelixProjectSummary: engagementHelixProjectSummaryReducer,
		engagementId: setEngagementIdReducer,
		engagementMetaData: engagementMetaDataReducer,
		engagementTeamMembers: engagementTeamMembers,
		engagementUserForIndependence: SubmitIndependenceDataReducer,
		engagementUsersWithRoles: engagementUsersWithRoles,
		entityDocuments: entityDocumentReducer,
		errors: errorReducer,
		estimates: estimatesReducer,
		financialStatement: financialStatementReducer,
		form: formReducer,
		formActions: formActionsReducer,
		formFilteredActions: formFilteredActionsReducer,
		formBodies: formBodyReducer,
		formBodyData: formBodyDataReducer,
		formBodyDisplayData: formBodyDisplayDataReducer,
		formBodyDisplayDataForUpdating: formBodyDisplayDataForUpdateReducer,
		formBodyDisplayDataNoStoreUpdate: formBodyDisplayDataNoStoreUpdateReducer,
		formBodyRelatedDocuments: formBodyRelatedDocumentsReducer,
		formOverwriteData: formOverwriteDataReducer,
		formProfileData: formProfileDataReducer,
		formProfileUpdateData: formProfileUpdateDataReducer,
		formUsers: formUsersReducer,
		fourFortyGlDocuments: fourFortyGlDocumentsReducer,
		goToSource: goToSourceReducer,
		groupAudit: groupAuditReducer,
		hasBodyIdFilter: setHasBodyIdFilterReducer,
		helixAccountsMappingStatus: areAllCanvasAccountsMappedToHelixAccountsReducer,
		helixProjects: helixReducer,
		helixSnapshot: helixsnapshotreducer,
		independenceActionEngagementUser: SubmitIndependenceActionReducer,
		independenceIndividualDocumentId: IndividualIndependenceDocumentReducer,
		internalUser: internalUserReducer,
		internalUsers: internalUsersReducer,
		isAresView: setIsAresViewReducer,
		navigationFilter: setNavigationFilterReducer,
		isCompareResponsesView: setIsCompareResponsesViewReducer,
		isDrawerMode: setIsDrawerModeReducer,
		isGuidedWorkFlowV2: setIsGuidedWorkFlowV2Reducer,
		isLoading: loadingReducer,
		isMediaPlaying: mediaPlayingReducer,
		isModalOpen: modalOpenStateReducer,
		isADCModalOpen: adcModalOpenStateReducer,
		modalLevel: modalLevelStateReducer,
		isStandaloneView: standaloneViewReducer,
		isTrackChangesView: setIsTrackChangesViewReducer,
		itapplication: itApplicationReducer,
		itapplicationData: itApplicationDataReducer,
		itAppSODetails: itApplicationDetailsReducer,
		itcontrolDetails: itcontrolDetailsReducer,
		itControls: itcontrolreducer,
		itprocess: itProcessReducer,
		itrisk: itRiskReducer,
		journalSource: journalSourceReducer,
		knowledgeForms: knowledgeFormsReducer,
		languages: getLanguagesReducer,
		limitedRiskDocuments: limitedRiskDocumentsReducer,
		manageObjects: manageObjectsReducer,
		materiality: materialityReducer,
		multiEntity: multiEntityReducer,
		newRisk: newRiskReducer,
		paansUserData: paansReducer,
		pspIndexes: pspIndexesReducer,
		quickLink: quickLinkReducer,
		rbacRoles: rbacUserRolesReducer,
		relateItRisks: relateItRiskReducer,
		deficiencyItRisks: deficiencyItRisksReducer,
		relatedDocuments: relatedDocumentsReducer,
		relatedObjects: relatedObjectsReducer,
		reviewNotes: reviewNotesReducer,
		risk: riskReducer,
		riskFactors: riskFactorReducer,
		risks: risksReducer,
		standardRisks: standardRisksReducer,
		riskData: risksListReducer,
		listRisksData: listRisksReducer,
		riskTypes: riskTypeReducer,
		modalRisks: modalRisksReducer,
		allEngagementRisks: getAllEngagementRisksReducer,
		rnhNoteDetail: noteDetailsReducer,
		roles: engagementUserRolesReducer,
		sampleItems: sampleItemReducer,
		filterData: filterDataReducer,
		filter: filterReducer,
		sampleList: sampleListReducer,
		sampleItemDocuments: sampleItemDocumentReducer,
		scot: scotReducer,
		scots: scotsReducer,
		walkThroughScots: scotsWalkthroughReducer,
		scotsDetails: scotsDetailsReducer,
		scotMetrics: scotMetricsReducer,
		sectionRelatedObjects: sectionRelatedObjectsReducer,
		showHideLeftSideSnapshotView: showHideLeftSideSnapshotViewReducer,
		showHideRightSideSnapshotView: showHideRightSideSnapshotViewReducer,
		signOffs: signOffsReducer,
		snapshotCompareDetails: snapshotCompareDetailsReducer,
		snapshotDetails: snapshotDetailsReducer,
		craSnapshotDetails: craSnapshotDetailsReducer,
		itEnvironmentSnapshotDetails: getITEnvironmentSnapshotById,
		snapshots: snapshotsReducer,
		stEntities: stEntitiesReducer,
		submitProfileDetails: SubmitProfileDataReducer,
		tagItems: tagsreducer,
		taskList: taskListReducer,
		taskRelateUnrelate: taskRelateUnrelateReducer,
		timePhases: timephaseReducer,
		toasterDetails: setFormV2ToasterVisibilityReducer,
		topHeader: topHeaderReducer,
		leadsheet: leadsheetReducer,
		trialBalance: trialBalanceByIdReducer,
		trialBalances: trialBalancesReducer,
		trialBalancesMetrics: trialBalancesMetricsReducer,
		uploadDocuments: uploadDocumentReducer,
		userData: userSearchReducerGA,
		userDetail: userreducer,
		userPreferences: userPreferencesReducer,
		userPresence: userPresenceReducer,
		userSearchResults: userSearchReducer,
		validationdetails: validationDetailsReducer,
		validations: validationCountsReducer,
		auditPlanSummaryValidations: auditPlanSummaryValidationsReducer,
		withoutapprovalvalidations: withoutApprovalvalidationCountsReducer,
		leftPanelValidationFilterValue: validationFilterValueReducer,
		wcgw: wcgwReducer,
		wcgws: wcgwsReducer,
		wcgwRelatedRisks: wcgwRelatedRisksReducer,
		relateRisks: relateRiskReducer,
		wcgwTasks: taskListReducerForWCGW,
		workspaceEngagements: workspaceEngagementsReducer,
		workspaceMetaData: workspaceReducer,
		manageAccounts: manageAccountsReducer,
		manageAccount: manageAccountReducer,
		flowChart: flowChartReducer,
		flowCharts: flowChartsReducer,
		flowchartStep: flowchartstepReducer,
		ovsProject: projectReducer,
		aiChatBotIntegrationParameters: AIChatBotIntegrationParametersReducer,
		adobeAnalytics: adobeAnalytics.adobeAnalyticsReducer,
		itPlanning: itPlanningReducer,
		documentTypes: documenttypesreducer,
		formDetailsOpenedInDrawer: DrawerFormDetailsReducer,
		entityLayers: entityLayersReducer,
		craAccountValidationCount: craAccountValidationCountReducer,
		deficiencies: deficienciesReducer,
		manageDeficiencies: manageDeficienciesReducer,
		deficiency: deficiencyReducer,
		deficiencymetrics: deficiencymetricsreducer,
		deficiencyClassTypes: deficiencyClassTypesReducer,
		knowledgeTechnologies: knowledgeTechnologyReducer,
		misstatementDetails: misstatementDetailsReducer,
		misstatements: misstatementsReducer,
		engagementTags: engagementTagsReducer,
		engagementTag: engagementTagReducer
	},
	{
		manifest: reducerManifest,
		ignoreActions: ['HOME_LOGIN'],
		log: Env.allowDrydocks()
	}
);

// Root reducer wrapper to handle RESET_STATE action
const rootReducer = (state, action) => {
	// When RESET_STATE action is dispatched, return the initial state
	if (action.type === 'RESET_STATE') {
		return initialState;
	}
	// Otherwise, pass the state to the appReducer
	return appReducer(state, action);
};

export default rootReducer;
